// 2026-05-26 - FormuLearning - Step 4 카드 컨테이너
// 2026-07-21 수정 - 이슈 #43: 화면 통제 단위를 추천 회차(run_id)에서 배치(batch_code)로 전환.
//                   RunHistorySection 드롭다운 → 통합표 필터로 흡수, 통합표는 활성 Lot의
//                   init+opti 전 배치를 배치 목록 API 하나에서 읽는다.
// 2026-08-30 수정 - 이슈 #58 S3(#66): 택1 확정·재생성 3지선다 폐기(BR-S4-L15·BR-LOT-13).
//                   추천은 전량 채택되어 라운드가 추가되고(BR-RND-02·03), 초기 설계 재생성은
//                   서버가 결과 유무로 판정한다(BR-RND-10).
// 2026-08-31 수정 - 이슈 #58 S5 2차(#68): Y 변수 정의·결과 양식 다운로드를 통합표로 내린다
//                   — 결과 입력 패널(`COMP-TEST-RESULT-PANEL`)이 소비한다(`M84-12`·`63`).
// 2026-08-31 수정 - 이슈 #58 S5 5차(#68, M84-75): 엑셀 진입점 정리에 따라 `Download
//                   Template`·`Upload Results (all batches)` 핸들러를 걷는다. 남는 것은
//                   `Download Current Profiles` 하나다. 사장돼 있던 `UploadSection.tsx` 도
//                   삭제했다(import 0 · 주석만 잔존). 백엔드 엔드포인트는 그대로다.
// 2026-08-31 수정 - 이슈 #58 S2(#65): 대조약 후보·라운드 목록을 읽어 Next Optimization
//                   에 하달한다. 추천 요청이 **대조약과 학습 경계를 싣고 간다**
//                   (BR-RND-04·07). 422(조건 불일치 Lot)는 화면 안내로 되받는다.
// 2026-09-01 수정 - 이슈 #58 S10 2차(#70, M84-60·61): S1 이 세워 둔 Round 계약 2종에
//                   화면을 붙인다. `COMP-FORMULATION-NAMING` 을 **가장 첫 부분**에 두고
//                   (UI/UX v2.2 §4.7 §4.0), 라운드 축은 여기가 쥐되 **필터는 통합표가**
//                   건다 — f2 추이 차트(전 라운드)와 Next Optimization 의 KPI(누적)는
//                   라운드로 좁히면 안 되기 때문이다. **백엔드 무변경.**
// 2026-09-01 수정 - 이슈 #58 S10 3차(#70, M84-36·69·13): 완료가 **최종 처방을 싣고 간다**.
//                   완료 진입점을 `CompletionSection` 한 곳으로 줄이고(`Stop Optimization`
//                   철거), 라운드별 처방표 경로를 `IntegrationTable` 로 옮긴다.
// 2026-09-21 수정 - 이슈 #69(S6): 대조약 후보를 통합표 §4.4 분석 구획에도 내린다(M84-24).
// 2026-09-21 수정 - 이슈 #20: `RunsSection` 에 X 변수를 내려 실험 횟수 하한 D+1(BR-S3-09)을 판정하게 한다.
// 2026-09-22 수정 - 이슈 #67 S4-2: Step 4 의 활성 Lot 전환(handleSwitchLot)을 걷는다 — `BR-LOT-08`(v1.10)이
//                   폐기한 기능이 남아 있었고, Y 파생이 활성 Lot 을 따르게 되면서(`BR-RND-05`) Step 4 가
//                   Y 를 바꾸는 경로가 됐다. 전환은 Step 3 탭 전용이다(UI/UX v2.5 `COMP-ACTIVE-LOT-BANNER`).
// 2026-09-23 수정 - 이슈 #67 S4-4: 추천이 **작업**으로 바뀐다 — 등록(202) 뒤 진행 표시가 스트림으로 단계를
//                   따라가고, 반영(라운드·배치 생성)이 끝나면 새 라운드로 전환한다. 409 는 오류가 아니라 진행 중
//                   작업에 붙고, 새로고침 뒤에는 `active_jobs` 로 다시 붙는다(UI/UX v2.6 COMP-OPTIMIZATION-PROGRESS).
//                   KPI 폐기 필드를 걷는다(인터페이스 v1.14 §2.6).
// 2026-09-23 수정 - 이슈 #67 S4-7: Next Optimization 아래에 최적화 결과 구획(`OptimizationResult` — 성분 중요도 ·
//                   현재까지 요약 · 추천 카드)을 둔다(UI/UX v2.7 §4.6·§4.7). 재조회마다 `revision` 을 올려 분석도 다시 읽게 한다.
// 2026-09-23 수정 - 이슈 #83: 추천 작업을 진행 중 작업 잠금(#82 `busyStore`)에 등록한다 — 등록 직후·409·재부착 모두
//                   `job` 에 묶인 effect 로 등록·해제. **Break** = 확인창 → `cancelOptimizationJob`(반영 중이면 거부).
// 2026-09-24 수정 - 이슈 #76(G5): ① 용출 입력 뼈대 = **배치 라운드의 격자 snapshot − 계산 제외**(M901-29·30) — 종전
//                   활성 Lot 프로파일 일률. 라운드마다 한 번 만들어 둔다(그리드가 참조 동일성으로 재시드하므로).
//                   ② 용출 저장을 진행 수에 올린다 — 저장 중·미저장 편집이 있으면 Next Optimization 잠금(M901-32).
// 2026-11-02 수정 - 이슈 #101: 초기 설계 생성 422(합 100% 불가 X 범위) 사유를 알린다 · 추천 카드에 X·총중량을 내린다.
// 2026-11-03 수정 - 이슈 #114: viewer(조회 전용) — 라운드 전환은 서버 호출 없이 화면 안에서만(장지연 교수 261103 D1=B).
//   서버 `current_runs` 는 서버 현재 라운드 것뿐이라, 다른 라운드는 통합표 배치(`getLotBatches` 전량)에서 골라 결과 카드에 넘긴다.
// 2026-11-03 수정 - 이슈 #102: 성분표·Next Optimization 에 `runs_algorithm` 을 내린다(User Define 빈칸·진행 게이트) ·
//                   Generate 는 총중량이 있어야 열린다(«총중량을 먼저 입력하십시오», 장지연 교수 261103).
// 파일 위치: frontend/src/features/step4/Step4Card.tsx

import { useEffect, useMemo, useState, useCallback, useRef } from 'react'
import { useProjectStore } from '../../stores/projectStore'
import { useLotSync } from '../../stores/lotStore'
import {
  getStep4, getOptimizationJob, requestOptimize, cancelOptimizationJob, completeOptimization, saveStep4Dissolution,
  downloadFile, dissolutionProfilesUrl, optimizeErrorDetail,
} from '../../api/step4'
import type { ExcludedBatch, OptimizationJobSummary, Step4Data, Step4Run } from '../../api/step4'
import {
  getLotBatches, getReferenceLotCandidates, apiErrorDetail,
  type LotBatch, type LotBatchesResponse, type ReferenceLotCandidate,
} from '../../api/lot'
import { getRounds, setCurrentRound, setFormulationPrefix, type RoundListItem } from '../../api/round'
import type { OptimizeOptions } from '../../api/step4'
// 회의(260602) 결정 — Initial design algorithm + Sample test result을 Step3에서 Step4로 이동.
// 백엔드(step3 데이터·엔드포인트)는 그대로 두고 화면만 재배치한다(프런트 재배치).
import { getStep3, updateStep3, generateRuns, saveStep3Dissolution, normalizeRldExperiment } from '../../api/step3'
import type { DissolutionProfile, Step3Data } from '../../api/step3'
// 2026-08-14 - 이슈 #60(M84-71): 두 컴포넌트가 `features/step3/`에 있으면서 여기서 렌더돼
// 소관이 오해를 불렀다. `features/step4/`로 이동하고 경로를 소관에 맞췄다.
import FormulationNaming from './FormulationNaming'
import RunsSection from './RunsSection'
import TestResultSection from './TestResultSection'
import IntegrationTable from './IntegrationTable'
import NextOptimizationCard, { type RunError } from './NextOptimizationCard'
import type { ProgressEnd } from './OptimizationProgress'
// 2026-07-23 - 이슈 #50 S-1: ConvergenceChart(iteration 축)는 IntegrationTable 내부의
// BatchF2Chart(batch 축)로 대체. UploadSection 은 이후 어디서도 렌더되지 않은 채 남아 있다가
// S5 5차(M84-75)에서 파일째 삭제됐다.
import CompletionSection from './CompletionSection'
import OptimizationResult from './OptimizationResult'
import { prescriptionUrl } from '../../api/step4'
import { useBusyStore } from '../../stores/busyStore'
import { trackSave, useStep4Pending } from '../../stores/step4PendingStore'
import { applyExclusion, roundGrid } from './gridExclusion'
import type { PhProfile } from '../../api/step3'
import { toast } from '../../stores/toastStore'
import { useCanWrite } from '../../hooks/useCanWrite'
import { isReadOnly } from '../../lib/readOnly'

const EMPTY_KPI: Step4Data['kpi'] = {
  target: { response: '', direction: 'maximize', value: null, best: null, achieved: false },
  f2_series: [],
}

function normalizeStep4(d: Step4Data): Step4Data {
  return {
    ...d,
    current_runs: d.current_runs ?? [],
    kpi: d.kpi ?? EMPTY_KPI,
    active_jobs: d.active_jobs ?? [],
    optimization_config: {
      n_recommendations: d.optimization_config?.n_recommendations ?? 3,
    },
  }
}

/** 작업 실패 사유 → 사람이 읽는 문구(UI/UX v2.6 §5.9 COMP-OPTIMIZATION-PROGRESS «실패»). */
function jobFailureMessage(job: OptimizationJobSummary | null, fallback?: string): string {
  const code = job?.error?.code
  if (code === 'timeout') return '계산 시간이 상한을 넘었습니다.'
  if (code === 'interrupted') return '계산이 중단됐습니다.'
  if (code === 'apply_failed') return '계산은 끝났으나 결과를 반영하지 못했습니다.'
  if (code === 'cancelled') return '추천이 중단됐습니다.'
  const detail = job?.error?.message ?? fallback
  return `계산 중 오류가 발생했습니다${detail ? ` — ${detail}` : '.'}`
}

/** viewer(#114) 라운드 결과 — 서버 `current_runs` 에 그 라운드가 없으면(화면 안에서만 고른 라운드)
 *  통합표 배치에서 opti 를 골라 같은 형태로 맞춘다. AI 해설은 통합표 응답 `ai_commentary_ko` 가 준다(`backend/app/lot/service.py` `batch_dict`). */
function resultRuns(current: Step4Run[], batches: LotBatch[], roundId: string | null, canWrite: boolean): Step4Run[] {
  const server = current.filter((r) => r.round_id === roundId)
  if (canWrite || server.length > 0) return server
  return batches
    .filter((b) => b.batch_type === 'opti' && b.round_id === roundId)
    .map((b) => ({
      id: b.id,
      run_id: b.round_no ?? 0,
      round_id: b.round_id,
      batch_code: b.batch_code,
      batch_type: b.batch_type,
      recommended_x: b.recommended_x,
      actual_x: b.x_values,
      y_values: b.y_values,
      dissolution_profiles: b.dissolution_profiles,
      f2: b.f2,
      f2_by_solution: b.f2_by_solution,
      f2_reason: b.f2_reason,
      predicted: b.predicted,
      ai_commentary_ko: b.ai_commentary_ko ?? null,
      is_excluded: b.is_excluded,
      status: b.status as Step4Run['status'],
    }))
}

export default function Step4Card() {
  const projectId = useProjectStore((s) => s.currentProject?.id)
  const [data, setData] = useState<Step4Data | null>(null)
  const canWrite = useCanWrite()
  // 활성 Lot의 시험 배치(init+opti) + Lot 문맥 — 통합표의 단일 소스(#43).
  const [batches, setBatches] = useState<LotBatch[]>([])
  const [lotInfo, setLotInfo] = useState<Omit<LotBatchesResponse, 'batches'> | null>(null)
  // 등록 요청 왕복 중. 등록이 끝나면 진행은 `job` 이 쥔다.
  const [submitting, setSubmitting] = useState(false)
  // 진행 중 추천 작업(BR-OPT-11 — 프로젝트당 1개). 있으면 진행 표시를 보이고 입력·실행을 잠근다.
  const [job, setJob] = useState<{ id: string; excluded: ExcludedBatch[] } | null>(null)
  const jobRef = useRef<string | null>(null)
  // Break 왕복 중(#83) — 중단 요청을 보냈고 응답을 기다린다.
  const [breaking, setBreaking] = useState(false)
  const [completing, setCompleting] = useState(false)
  // 추천 실행 결과 안내(BR-RND-02·03) — "라운드 N 추가 · 배치 M개 생성". 후보 목록이 아니다.
  const [runNotice, setRunNotice] = useState<string | null>(null)
  // 추천 거부(422 사유)·작업 실패 안내 — 서버 사유를 그대로 보인다.
  const [runError, setRunError] = useState<RunError | null>(null)
  // 대조약 후보(BR-RND-08) · 라운드 목록(BR-RND-07) — S1 이 세워 둔 계약의 소비처다.
  const [refCandidates, setRefCandidates] = useState<ReferenceLotCandidate[]>([])
  const [rounds, setRounds] = useState<RoundListItem[]>([])
  // 보고 있는 라운드(M84-61) — 서버가 쥔 `step4_data.current_round_id` 의 화면 사본.
  const [roundId, setRoundId] = useState<string | null>(null)
  const [roundBusy, setRoundBusy] = useState(false)
  // 재조회 횟수 — 최적화 결과 구획이 분석을 다시 읽는 계기다(결과 저장·제외 등이 분석을 다시 등록한다, BR-OPT-16).
  const [revision, setRevision] = useState(0)
  // Step3에서 이관된 Initial Design Algorithm + Sample Test Results 상태(데이터 소유는 step3 백엔드).
  const [step3, setStep3] = useState<Step3Data | null>(null)
  const [generating, setGenerating] = useState(false)
  // 2026-09-09(#72, M901-20): **실제로 설계를 만든** 알고리즘. 선택은 즉시 저장되므로
  //   저장값만으로는 «고르기만 한 것»과 «생성까지 된 것»을 가릴 수 없다. 덮어쓰기를
  //   취소했을 때 되돌릴 자리가 이것이다.
  const generatedAlgoRef = useRef<'lhs' | 'random' | 'user_defined' | null>(null)

  const initBatches = batches.filter((b) => b.batch_type === 'init')

  // 2026-07-23 - 이슈 #50(F-8): Step 3 탭에서 활성 Lot이 바뀌면 revision이 올라 재조회한다.
  const lotRevision = useLotSync((s) => s.revision)

  // 진행 중 작업에 붙는다 — 학습 제외 목록은 작업 조회가 싣는다(409 응답·active_jobs 에는 없다).
  const attachJob = useCallback(async (jobId: string) => {
    if (!projectId || jobRef.current === jobId) return
    jobRef.current = jobId
    setRunError(null)
    setJob({ id: jobId, excluded: [] })
    try {
      const view = await getOptimizationJob(projectId, jobId)
      if (jobRef.current === jobId) setJob({ id: jobId, excluded: view.excluded ?? [] })
    } catch {
      // 제외 목록은 부가 정보다 — 진행 표시는 스트림이 잇는다
    }
  }, [projectId])

  const refresh = useCallback(async () => {
    if (!projectId) return
    const [d, b, s3, cand, rnd] = await Promise.all([
      getStep4(projectId), getLotBatches(projectId), getStep3(projectId),
      getReferenceLotCandidates(projectId), getRounds(projectId),
    ])
    setData(normalizeStep4(d))
    // viewer(#114) — 화면 안에서 고른 라운드를 재조회가 서버 값으로 되돌리지 않는다.
    setRoundId((prev) => (isReadOnly() && prev ? prev : d.current_round_id))
    setBatches(b.batches ?? [])
    setRefCandidates(cand.candidates ?? [])
    setRounds(rnd.rounds ?? [])
    setLotInfo({
      active_lot_no: b.active_lot_no,
      active_lot_label: b.active_lot_label,
      total_lots: b.total_lots,
      has_reference: b.has_reference,
      lots: b.lots ?? [],
    })
    setStep3(s3)
    setRevision((n) => n + 1)
    // 진행 중 추천이 있으면 그 작업에 다시 붙는다 — 새로고침·재진입·다른 탭이 시작한 추천(BR-OPT-13).
    const running = (d.active_jobs ?? []).find((j) => j.job_type === 'suggest')
    if (running && jobRef.current !== running.id) {
      void attachJob(running.id)
    }
    // 2026-09-09(#72, M901-20): 이미 설계점이 있으면 저장된 알고리즘이 곧 «생성에 쓰인
    //   것»이다. 프로젝트를 열자마자 덮어쓰기를 취소해도 되돌릴 자리가 있어야 한다.
    if (generatedAlgoRef.current == null && (s3.runs?.length ?? 0) > 0) {
      generatedAlgoRef.current = s3.runs_algorithm
    }
  }, [projectId, attachJob])

  useEffect(() => {
    generatedAlgoRef.current = null   // 프로젝트가 바뀌면 직전 알고리즘 기억도 버린다
    useStep4Pending.getState().reset()   // 저장 진행·미저장 표식은 프로젝트 단위다(#76)
    jobRef.current = null
    setJob(null)
    setBreaking(false)
    refresh()
    setRunNotice(null)
    setRunError(null)
  }, [refresh, lotRevision])

  // --- Initial Design Algorithm (step3 소유) ---
  // 2026-09-09(#72, M901-20): 선택은 여기서 **즉시 저장**된다. 그런데 종전에는 생성이
  //   결과 보유 시 건너뛰어져, `Random` 이 찍힌 채 LHS 설계가 남았다 — 회의의 *"lhs,
  //   random 이 생성시키면 똑같이 나온다"* 가 이 어긋남이다. 그래서 생성이 무산되면
  //   `handleGenerate` 가 **선택도 되돌린다**(아래).
  const handleAlgoChange = useCallback(async (algo: 'lhs' | 'random' | 'user_defined') => {
    if (!projectId) return
    const updated = await updateStep3(projectId, { runs_algorithm: algo })
    setStep3(updated)
  }, [projectId])

  const handleCountChange = useCallback(async (n: number) => {
    if (!projectId) return
    const updated = await updateStep3(projectId, { runs_count: n })
    setStep3(updated)
  }, [projectId])

  // 2026-08-30 - 이슈 #58 S3(BR-RND-10): 3지선다 모달을 걷었다. **서버가 결과 유무로 판정**한다
  // — 결과가 없으면 묻지 않고 대체하고, 있으면 보존하며 그 사실을 응답으로 알린다.
  // 결과 없는 설계를 지우는 데 확인을 요구할 이유가 없다.
  // 2026-09-09 수정 - 이슈 #72(M901-20): **무조건 보존을 걷고 묻는다.** 보존만 하면
  //   알고리즘을 바꿔 다시 눌러도 화면이 그대로여서 «LHS 와 Random 이 똑같이 나온다» 로
  //   읽힌다. 확인하면 `overwrite` 로 대체하고, **취소하면 알고리즘 선택도 되돌린다** —
  //   선택은 바뀌고 결과는 안 바뀌는 어긋남이 오해의 직접 원인이다.
  const handleGenerate = useCallback(async () => {
    if (!projectId || !step3?.runs_algorithm) return
    const algo = step3.runs_algorithm
    const prevAlgo = generatedAlgoRef.current
    setGenerating(true)
    setRunNotice(null)
    try {
      let res = await generateRuns(
        projectId, algo, step3.runs_count ?? 8, step3.x_variables ?? [])
      if (res.preserved_count > 0) {
        const ok = window.confirm(
          `초기 설계에 결과가 입력된 배치가 ${res.preserved_count}건 있습니다.\n\n`
          + '값을 삭제하고 새 초기값으로 덮어쓸까요?\n'
          + '입력된 실험 결과와 용출 프로파일이 함께 사라집니다.',
        )
        if (ok) {
          res = await generateRuns(
            projectId, algo, step3.runs_count ?? 8, step3.x_variables ?? [], true)
          setRunNotice(`기존 초기 설계 ${res.deleted_count}건을 덮어썼습니다.`)
        } else {
          // 되돌림 — 생성이 무산됐으므로 화면에 남은 알고리즘 선택도 직전 값으로 돌린다.
          if (prevAlgo && prevAlgo !== algo) {
            const reverted = await updateStep3(projectId, { runs_algorithm: prevAlgo })
            setStep3(reverted)
          }
          setRunNotice(`기존 초기 설계 ${res.preserved_count}건을 그대로 두었습니다.`)
          return
        }
      }
      generatedAlgoRef.current = algo   // 실제로 설계를 만든 알고리즘만 기억한다
      await refresh()
    } catch (err) {
      // 2026-11-02(#101): X 범위로 합 100% 처방을 만들 수 없으면 서버가 422 로 사유를 준다(BR-S3-03).
      window.alert(apiErrorDetail(err) ?? '초기 설계 생성에 실패했습니다.')
    } finally {
      setGenerating(false)
    }
  }, [projectId, step3, refresh])

  // 2026-07-23 - 이슈 #50: 용출프로파일 양식 다운로드. <a href>는 Bearer가 없어 401이
  // 나므로 blob 다운로드로 받는다. 공양식(template)은 S5 5차에서 진입점이 걷혔다(M84-75).
  const handleDownloadProfiles = useCallback(async () => {
    if (!projectId) return
    await downloadFile(dissolutionProfilesUrl(projectId), 'dissolution_profiles.xlsx')
  }, [projectId])

  // --- 용출 프로파일 그리드 저장 (이슈 #42). 저장 즉시 백엔드가 f2를 재계산한다. ---
  // 저장 엔드포인트는 배치 유형별로 갈린다(init=step3, opti=step4). 통합표는 배치를
  // 그대로 넘기고 여기서 경로를 가른다(#43).
  const handleSaveDissolution = useCallback(async (batch: LotBatch, profiles: DissolutionProfile[]) => {
    if (!projectId) return
    // 저장 진행 수에 올린다 — 끝나기 전에는 Next Optimization 을 잠근다(#76, M901-32). 재조회까지가 저장이다.
    await trackSave(async () => {
      if (batch.batch_type === 'init') {
        await saveStep3Dissolution(projectId, batch.id, profiles)
      } else {
        await saveStep4Dissolution(projectId, batch.id, profiles)
      }
      await refresh()
    })
  }, [projectId, refresh])

  // 2026-09-23 - 이슈 #67 S4-4: 추천은 **작업 등록**이다(202). 계산은 optimizer 가 하고, 성공하면 반영에서
  // optimization round 1개와 추천 전량 배치가 생긴다(BR-RND-02·03 · BR-OPT-12). 진행은 `OptimizationProgress`
  // 가 스트림으로 따라간다. 409 는 이미 진행 중인 작업이 있다는 뜻이라 오류로 보이지 않고 그 작업에 붙는다.
  const handleOptimize = useCallback(async (nRecs: number, opts: OptimizeOptions) => {
    if (!projectId) return
    setSubmitting(true)
    setRunNotice(null)
    setRunError(null)
    try {
      const res = await requestOptimize(projectId, nRecs, opts)
      jobRef.current = res.job.id
      setJob({ id: res.job.id, excluded: res.excluded })
    } catch (e) {
      const detail = optimizeErrorDetail(e)
      if (detail === null) throw e
      if (detail.status === 409 && detail.job_id) {
        await attachJob(detail.job_id)
      } else {
        // 422 — 대조약·목적함수·목표값·조성·학습 행 사유(인터페이스 v1.14 §2.6). 사유를 삼키면
        // 사용자가 무엇을 고쳐야 하는지 모른 채 버튼만 다시 누른다.
        setRunError({ message: detail.message, excluded: detail.excluded })
      }
    } finally {
      setSubmitting(false)
    }
  }, [projectId, attachJob])

  // 작업 끝 — done 이면 새 라운드로 전환(재조회가 current_round 를 따른다), error 면 사유와 다시 실행.
  const handleJobEnd = useCallback((end: ProgressEnd) => {
    jobRef.current = null
    setJob(null)
    setBreaking(false)
    if (end.event === 'done') {
      const { round, batches: made } = end.data
      if (round && made) {
        setRunNotice(`Optimization Round #${round.round_no - 1}이 추가되고 처방 ${made.length}건이 생성됐습니다`
          + ` (${made.map((b) => b.batch_code).join(', ')}).`)
      }
    } else {
      setRunError({ message: jobFailureMessage(end.data.job, end.data.message), failed: true })
    }
    void refresh()
  }, [refresh])

  // 2026-09-23 - 이슈 #83: 추천 중단. 대기·진행 중이면 작업이 닫히고 라운드·배치는 생기지 않는다. 계산이 끝나
  // 반영 중(`applying`)이면 중단하지 않는다 — 곧 `done` 이 온다(Step 1 «저장 중 중단은 저장 완료를 기다린다» 와 같다).
  const handleBreak = useCallback(async () => {
    const jobId = jobRef.current
    if (!projectId || !jobId || isReadOnly()) return   // viewer(#114) — 중단은 쓰기다
    const ok = window.confirm(
      '최적화 추천을 중단할까요?\n\n중단하면 이번 추천의 라운드·처방이 만들어지지 않습니다.\n'
        + '계산이 이미 끝나 반영 중이면 중단되지 않고 곧 완료됩니다.',
    )
    if (!ok || jobRef.current !== jobId) return
    setBreaking(true)
    let status: string
    try {
      status = await cancelOptimizationJob(projectId, jobId)
    } catch {
      setBreaking(false)
      toast('중단 요청에 실패했습니다. 다시 시도하세요.', 'warn')
      return
    }
    if (jobRef.current !== jobId) return      // 그사이 스트림이 끝을 알렸다
    if (status === 'cancelled') {
      jobRef.current = null
      setJob(null)
      setBreaking(false)
      setRunNotice('최적화 추천을 중단했습니다. 라운드·처방은 만들어지지 않았습니다.')
      void refresh()
    } else {
      // applying — 반영이 끝나면 스트림이 done 을 보낸다. 이미 끝난 작업도 스트림이 끝을 알린다.
      setBreaking(false)
      if (status === 'applying') toast('계산이 끝나 결과를 반영하는 중입니다 — 곧 완료됩니다.', 'info')
    }
  }, [projectId, refresh])

  // 진행 중 작업 전역 등록(#82·#83) — `job` 에 묶여 해제가 빠지지 않는다(작업 끝·중단·프로젝트 전환·언마운트).
  const handleBreakRef = useRef(handleBreak)
  useEffect(() => { handleBreakRef.current = handleBreak })
  const jobId = job?.id
  useEffect(() => {
    if (!jobId) return
    useBusyStore.getState().begin({
      id: jobId, step: 4, label: 'Step 4 최적화 추천',
      // viewer(#114) — 다른 계정이 시작한 추천을 지켜볼 수만 있다. Break 진입점(헤더)을 주지 않는다.
      cancel: isReadOnly() ? undefined : () => { void handleBreakRef.current() },
    })
    return () => useBusyStore.getState().end(jobId)
  }, [jobId])
  useEffect(() => {
    if (jobId) useBusyStore.getState().update(jobId, { phase: breaking ? 'breaking' : 'running' })
  }, [jobId, breaking])
  const handleJobStage = useCallback((p: { index: number; total: number; label: string }) => {
    const id = jobRef.current
    if (id) useBusyStore.getState().update(id, { progress: { done: Math.max(0, p.index), total: p.total, doing: p.label } })
  }, [])

  // 2026-09-01 - 이슈 #58 S10 2차(M84-61): 라운드 전환. **서버 상태**(`current_round_id`)를
  // 바꾸므로 재조회가 따라야 한다 — 현재 라운드 배치(`current_runs`)가 그 라운드에 걸려 있다. 낙관적 반영을 먼저 해 왕복 동안 옛 라운드를 보이지 않는다.
  const handleSelectRound = useCallback(async (rid: string) => {
    if (!projectId || rid === roundId) return
    // viewer(#114 D1=B) — 보고 있는 라운드는 프로젝트 공용 서버 상태라 바꾸지 않는다. 화면 선택만 옮긴다.
    if (isReadOnly()) {
      setRoundId(rid)
      return
    }
    setRoundBusy(true)
    setRoundId(rid)
    try {
      await setCurrentRound(projectId, rid)
      await refresh()
    } finally {
      setRoundBusy(false)
    }
  }, [projectId, roundId, refresh])

  // 2026-09-01 - 이슈 #58 S10 2차(M84-60): 접두어 저장. **재조회하지 않는다** — 기존 배치
  // 식별자는 부여 시점에 고정돼 바뀌지 않고(BR-S4-L13) 서버가 확정값을 되돌려 주므로
  // 화면이 다시 읽어야 할 것이 없다. 라운드 전환과 달리 파생 상태가 없다.
  const handleSavePrefix = useCallback(async (prefix: string) => {
    if (!projectId) throw new Error('project not loaded')
    const res = await setFormulationPrefix(projectId, prefix)
    setData((d) => (d ? { ...d, formulation_prefix: res.formulation_prefix } : d))
    return res
  }, [projectId])

  // 2026-09-01 - 이슈 #58 S10 3차(M84-36): 완료가 **최종 처방을 싣고 간다.**
  // 422 는 삼키지 않고 되던진다 — `CompletionSection` 이 서버 사유를 그 자리에 보인다.
  const handleComplete = useCallback(async (finalBatchId: string) => {
    if (!projectId) return
    setCompleting(true)
    try {
      await completeOptimization(projectId, finalBatchId)
      await refresh()
    } finally {
      setCompleting(false)
    }
  }, [projectId, refresh])

  // 대조약 프로파일 — 활성 Lot(폴백) · Lot id 별 · **라운드별 입력 뼈대**(#76). 그리드가 뼈대의 참조 동일성으로
  //   다시 시드하므로 렌더마다 새 배열을 만들지 않게 여기서 한 번 만든다.
  const refs = useMemo(() => {
    const rld = normalizeRldExperiment(step3?.rld_experiment)
    // 활성 Lot의 대조약 프로파일 — 라운드 격자 기록이 없을 때의 뼈대(이슈 #42).
    const active: PhProfile[] = rld.lots[rld.active_lot]?.ph_profiles ?? []
    // Lot id → 대조약 프로파일 — 추천 카드 예측 그래프의 점선은 그 라운드가 고른 대조약이다(BR-RND-04, 작업계획 D14).
    const byLot = new Map(rld.lots.filter((l) => l.id).map((l) => [l.id as string, l.ph_profiles ?? []]))
    // 라운드 id → 입력 뼈대 = 그 라운드 기준 Lot 프로파일 − 계산 제외(M901-29 «입력칸에서도 뺀다»·30).
    const byRound = new Map<string, PhProfile[]>()
    for (const r of rounds) {
      const g = roundGrid(r)
      if (!g) continue
      byRound.set(r.id, applyExclusion((g.lot_id && byLot.get(g.lot_id)) || active, g))
    }
    return { active, byLot, byRound }
  }, [step3, rounds])
  const referenceFor = useCallback(
    (b: Pick<LotBatch, 'round_id'>) => (b.round_id && refs.byRound.get(b.round_id)) || refs.active,
    [refs],
  )

  if (!data) return <p className="text-xs text-text-secondary">Loading...</p>

  // 보고 있는 라운드(M84-61). 서버가 아직 고르지 않았거나(신규 프로젝트) 사라진 라운드를
  // 가리키면 **마지막 라운드**로 해석한다 — 사용자가 작업 중인 자리가 거기다. 이 해석은
  // 화면 안에서만 하고 서버에 쓰지 않는다(진입만으로 서버 상태를 바꾸지 않는다).
  const currentRoundId = rounds.some((r) => r.id === roundId)
    ? roundId
    : (rounds.length > 0 ? rounds[rounds.length - 1].id : null)

  return (
    <div>
      {/* 0. Formulation Naming — 화면 **가장 첫 부분**(UI/UX v2.2 §4.7 §4.0, M84-60) */}
      <FormulationNaming
        prefix={data.formulation_prefix}
        onSave={handleSavePrefix}
      />

      {/* 1. Initial Design Algorithm — 초기 설계점 생성 */}
      <RunsSection
        algorithm={step3?.runs_algorithm ?? null}
        runsCount={step3?.runs_count ?? null}
        onAlgorithmChange={handleAlgoChange}
        onCountChange={handleCountChange}
        onGenerate={handleGenerate}
        generating={generating}
        xVariables={step3?.x_variables ?? []}
        totalWeightMg={step3?.total_weight_mg ?? null}
      />

      {/* 2. Sample Test Results — 현재 프로파일 내보내기 하나만 남았다(M84-75).
          배치별 표시·조작은 아래 통합표가 단독으로 담당한다(#43). */}
      <TestResultSection
        batchCount={initBatches.length}
        onDownloadProfiles={handleDownloadProfiles}
      />

      {/* 활성 Lot의 init+opti 전 배치 통합표 — 포함/제외·용출 입력·액션 이력 */}
      <IntegrationTable
        projectId={projectId!}
        batches={batches}
        lot={{
          activeLotNo: lotInfo?.active_lot_no ?? 1,
          label: lotInfo?.active_lot_label ?? '',
          totalLots: lotInfo?.total_lots ?? 1,
          hasReference: lotInfo?.has_reference ?? false,
        }}
        lots={lotInfo?.lots ?? []}
        rounds={rounds}
        currentRoundId={currentRoundId}
        onSelectRound={handleSelectRound}
        roundBusy={roundBusy}
        targetValue={data.kpi.target.value}
        xVariables={step3?.x_variables ?? []}
        totalWeightMg={step3?.total_weight_mg ?? null}
        runsAlgorithm={step3?.runs_algorithm ?? null}
        yVariables={step3?.y_variables ?? []}
        referenceFor={referenceFor}
        referenceCandidates={refCandidates}
        prescriptionHref={prescriptionUrl(projectId!)}
        onChanged={refresh}
        onSaveDissolution={handleSaveDissolution}
      />

      {/* 3. Optimization — Next Optimization 대시보드(F-10 · 이슈 #50 S-4~S-6 재구성) */}
      <NextOptimizationCard
        projectId={projectId!}
        batches={batches}
        referenceCandidates={refCandidates}
        rounds={rounds}
        nRecommendations={data.optimization_config.n_recommendations ?? 3}
        runNotice={runNotice}
        runError={runError}
        job={job}
        onJobEnd={handleJobEnd}
        onJobStage={handleJobStage}
        onJobBreak={handleBreak}
        jobBreaking={breaking}
        onOptimize={handleOptimize}
        onSaveDissolution={handleSaveDissolution}
        referenceFor={referenceFor}
        xVariables={step3?.x_variables ?? []}
        totalWeightMg={step3?.total_weight_mg ?? null}
        runsAlgorithm={step3?.runs_algorithm ?? null}
        optimizing={submitting || job != null}
        completing={completing}
        isCompleted={data.is_completed}
      />

      {/* §4.6·§4.7 최적화 결과 — 성분 중요도 · 현재까지 요약 · 추천 카드(COMP-FEATURE-IMPORTANCE ·
          COMP-RECOMMENDATION-CARD) · MOBO 진척도(잠정, Q-260917-03). Convergence(§4.8) = 통합표 안 용액별 f2 추이는
          그대로 두고 진척도와 병존한다(사용자 260923, #67 S4-8). */}
      <OptimizationResult
        projectId={projectId!}
        revision={revision}
        rounds={rounds}
        currentRoundId={currentRoundId}
        // 라운드 전환 왕복 중에는 옛 라운드 배치가 남아 있다 — 보고 있는 라운드 것만 넘긴다
        batches={resultRuns(data.current_runs, batches, currentRoundId, canWrite)}
        xVariables={step3?.x_variables ?? []}
        totalWeightMg={step3?.total_weight_mg ?? null}
        yVariables={step3?.y_variables ?? []}
        referenceByLot={refs.byLot}
        fallbackReference={refs.active}
      />

      {/* 4. Complete Optimization — **완료 진입점은 여기 하나다**(M84-36) */}
      <CompletionSection
        projectId={projectId!}
        batches={batches}
        isCompleted={data.is_completed}
        completedAt={data.completed_at}
        finalBatchId={data.final_batch_id}
        onComplete={handleComplete}
        completing={completing}
      />
    </div>
  )
}
